import React from "react";

export const Zone = (props) => (
  <section {...props} className={"zone-" + props.type} />
);

export const ZoneFull = (props) => <Zone {...props} type="full" />;
export const ZoneMosaic = (props) => (
  <Zone {...props} type="mosaic" data-mosaic-type={props.type} />
);

export const MosaicCell = (props) => <div {...props} className="mosaic-cell" />;

export const Aggregator = (props) => (
  <div className="aggregator">{props.children}</div>
);

export const Grid = (props) => (
  <div className="block-grid">
    <ul>
      {React.Children.map(props.children, (item) => (
        <li>{item}</li>
      ))}
    </ul>
  </div>
);
